export default __webpack_public_path__ + "static/media/email-sent.fd3b7692.svg";